export const ru = {
    add: 'Добавить',
    'audio-disable-reason': 'Используется из видеофайла',
    cancel: 'Отменить',
    converting: 'Обработка',
    crop: 'Обрезать',
    edit: 'Изменить',
    'idea-source': 'Выбрать другое со страницы',
    'library-source': 'Выбрать из библиотеки',
    'link-source': 'Загрузить по ссылке',
    'recent-source': 'Выбрать из ранее использованных',
    'smart-center': 'Установить смарт-центр',
    'upload-error': 'При загрузке файла произошла ошибка. Попробуйте позже.',
    'upload-source': 'Загрузить с компьютера'
};
